import React, { useEffect, useState } from 'react';
import { Dropdown, DefaultDropdownProps, Option, useDropdownHelper, FormFieldsData } from 'framework/form';
import usePositionService from '../positionService';
import { get } from 'lodash';

interface Props {
  isValueEqLabel?: boolean;
  additionalOptions?: Option[];
  positionValueKey?: string;
  onPositionChange?: (value?: string) => FormFieldsData;
}

const PositionDropdown = ({
  isValueEqLabel = false,
  positionValueKey,
  additionalOptions = [],
  onPositionChange = () => ({}),
  ...props
}: Omit<DefaultDropdownProps, 'options'> & Props) => {
  const { getRawOnChangeCallback } = useDropdownHelper(props);
  const rawOnChangeCallback = getRawOnChangeCallback();

  const { findAll } = usePositionService();
  const [options, setOptions] = useState<Option[]>([]);
  const valueKey = positionValueKey || (isValueEqLabel ? 'name' : 'id');

  useEffect(() => {
    (async () => {
      const positions = await findAll();
      const data = positions.map((position: any) => ({
        value: `${position[valueKey]}`,
        label: position.name,
      }));
      setOptions([...data, ...additionalOptions]);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChallengeCallback = (values: FormFieldsData) => {
    const selectedPosition = get(values, props.source);
    const extraData = onPositionChange(selectedPosition);
    rawOnChangeCallback?.({ ...values, ...extraData });
  };

  return <Dropdown placeholder="Select position" {...props} options={options} onChangeCallback={onChallengeCallback} />;
};

export default PositionDropdown;
